import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { portalPaths } from '@provision/portal-routes';
import { DynamicIcon } from 'src/components';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { useGetPortalioAuthDetails } from 'src/graphql/entities/integrations/portalio/hooks/use-get-portalio-auth-details';
import { DataImportItem } from 'src/pages/Settings/data-import/data-import-item';
import { DataImportProps } from 'src/pages/Settings/data-import/data-import.types';
import { Modals, useModalMethods } from 'src/store/modals';
import { useNavigateRoute } from 'src/utils/routing';

export const PortalioDataImportItem = ({ sx, size }: DataImportProps) => {
  const theme = useTheme();
  const { portalioAuthDetails } = useGetPortalioAuthDetails();
  const { showModal } = useModalMethods(Modals.ImportPortalioProjects);
  const portalioAuthed = !!portalioAuthDetails?.id;
  const { navigate } = useNavigateRoute();

  const { checkValidity, loading: loadingGroupRules } = useGroupRules();
  const allowPortalioDataImport =
    !loadingGroupRules && checkValidity([UserGroupRules.AccessToPortalioImportTool]);

  if (!allowPortalioDataImport) {
    return null;
  }

  return (
    <Grid size={size} sx={sx}>
      <DataImportItem
        onClick={
          portalioAuthed ? showModal : () => navigate(portalPaths.settings.integrations())
        }
        title="Portal.io"
        subTitle={portalioAuthed ? 'Connected' : 'Not Connected'}
        actionButtonText={portalioAuthed ? 'Import from Portal.io' : 'Go to Integrations'}
        actionButtonVariant={portalioAuthed ? 'contained' : 'outlined'}
        actionButtonTestId="import-portalio-projects-open"
        description="Import projects to automatically create sites, clients, and projects in ProVision."
        icon={
          <DynamicIcon
            name="wrench"
            library="lucide"
            size={24}
            sx={{ color: theme.palette.custom.tertiary.tertiary60 }}
          />
        }
      />
    </Grid>
  );
};
